import React from "react";
import { NavLink } from "react-router-dom";
import { Moon, Dumbbell, Pill, Sparkles, ChevronRight, Activity, GlassWater, Droplet, Scale, LayoutDashboard, User } from "lucide-react";

const links = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard },
  { to: "/sugar", label: "Blood Sugar", icon: Droplet },
  { to: "/bp", label: "Blood Pressure", icon: Activity },
  { to: "/weight", label: "Weight & BMI", icon: Scale },
  { to: "/water", label: "Water Intake", icon: GlassWater },
  { to: "/sleep", label: "Sleep", icon: Moon },
  { to: "/exercise", label: "Exercise", icon: Dumbbell },
  { to: "/medication", label: "Medication", icon: Pill },
  { to: "/assistant", label: "AI Assistant", icon: Sparkles },
  { to: "/profile", label: "Profile", icon: User },
];

export default function More() {
  return (
    <div className="p-5">
      <h1 className="text-3xl font-bold tracking-tight text-slate-900 mb-1">All sections</h1>
      <p className="text-sm text-slate-500 mb-6">Jump to any tracker</p>
      <div className="grid grid-cols-2 gap-3" data-testid="more-grid">
        {links.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`more-link-${to.replace(/\//g, "") || "home"}`}
            className="bg-white rounded-2xl border border-slate-200 p-4 flex items-center justify-between hover:shadow-md hover:border-slate-300 transition-all"
          >
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-blue-50 text-blue-600 grid place-items-center">
                <Icon className="w-4 h-4" />
              </div>
              <span className="text-sm font-medium text-slate-800">{label}</span>
            </div>
            <ChevronRight className="w-4 h-4 text-slate-400" />
          </NavLink>
        ))}
      </div>
    </div>
  );
}
